export default "__VITE_ASSET__CYin21su__";